import React, { useState } from 'react';
import { Card, CardActionArea } from '@material-ui/core';
import ctx from 'classnames';
import { AppCard } from '../AppCard';
import { CARDS_TO_SHOW, CarouselTypes } from '../Common/Carousels/config';
import { App, GlobalAppCollection } from 'models/app';
import { shuffleArray } from '../../utils/helpers';
import { APP_COLLECTION_NAME_MAX_LENGTH } from '../../utils/constants'
import { generateRoute, getBaseUrl } from '../../utils/location';
import { AppTile } from './tile';
import styles from './styles.module.scss';
import { readableFormat, detectLocale } from '../../utils/transformationHelper';
import { AppCollectionStyles } from '../../models/enums';
import { CarouselWrapper, carouselWrapperConfig } from '../Common/Carousels/CarouselWrapper';
import { Link as RouteLink } from 'react-router-dom';
import { AppMarketPageIdentifier } from '../../AppRoutes';

interface CollectionProps {
  collection: GlobalAppCollection;
}

export const AppCollectionCarousel: React.FC<CollectionProps> = ({ collection }) => {
  const baseUrl = getBaseUrl();
  const { carouselApps, collectionStyle, id } = collection;
  const collectionDisplayName = readableFormat(collection.displayName,APP_COLLECTION_NAME_MAX_LENGTH);
  const carousalName = collection.displayName?.toLowerCase().replace(/ /g, '_').replace(/!$/, '');
  const [bannerFile, setBannerFile] = useState<App[]>(shuffleArray(collection.carouselApps.map(app => app)));

  let carouselWrapperConfigToBuild: carouselWrapperConfig = {
    collectionDisplayName: collectionDisplayName,
    carousalName: carousalName,
    collectionId: id,
  };

  const removeAppFromCarousel = (appId: string) => {
    setBannerFile(bannerFile.filter(app => app.id !== appId));
  }

  if (collectionStyle === AppCollectionStyles.ScrollHeroBanner) {
      return (
        <CarouselWrapper carouselWrapperConfig={{ noHeader: true, carouselKey: CarouselTypes.Slider }}>
          {bannerFile.map(
            app =>
              app.filenameBanner &&
              (
                <div key={app.id}>
                  <Card variant="outlined" className={styles.hero}  tabIndex={-1}>
                    <RouteLink to={generateRoute(AppMarketPageIdentifier.AppDetails, app.id)} tabIndex={-1} aria-hidden={true} data-testid={`banner-link-${app.id}`}>
                      <CardActionArea disableRipple role='link' aria-label={app.name} >
                        <img src={(detectLocale(app)?.filenameBanner) || `${baseUrl}/v2/image/${app.filenameBanner}`} alt= {app.name} tabIndex={-1} height="384" width="100%"
                          onError={(e) => {
                            removeAppFromCarousel(app.id);
                          }}
                        />
                      </CardActionArea>
                    </RouteLink>
                  </Card>
                </div>
              ),
          )}
        </CarouselWrapper>
      );
  } else if (
    collectionStyle === AppCollectionStyles.ScrollGridTile
  ) {
    if (!carouselApps.length) return null;
    const top3Apps: App[] = carouselApps.slice(0, CARDS_TO_SHOW);
    carouselWrapperConfigToBuild.hideSeeAll = carouselApps.length <= CARDS_TO_SHOW;
    carouselWrapperConfigToBuild.slidesToShow = top3Apps.length < CARDS_TO_SHOW ? CARDS_TO_SHOW - 1 : CARDS_TO_SHOW;
    carouselWrapperConfigToBuild.carouselKey = CarouselTypes.Card;
    return (
      <CarouselWrapper carouselWrapperConfig={carouselWrapperConfigToBuild}>
        {top3Apps.map((app, index) => {
          return (
            <div className={ctx(styles.card, { [styles.col]: true })} key={app.id}>
              <AppCard app={app} />
            </div>
          );
        })}
      </CarouselWrapper>
    );
  }
  else if (  collectionStyle === AppCollectionStyles.ScrollTile ){
    carouselWrapperConfigToBuild.wrapInPaper = true;
    carouselWrapperConfigToBuild.carouselKey = CarouselTypes.Tile;
    return (
      <CarouselWrapper carouselWrapperConfig={carouselWrapperConfigToBuild}>
        {carouselApps.map(app => (
          <AppTile app={app} key={app.id} />
        ))}
      </CarouselWrapper>
    );
  }
 else return null;
};
